import type { CSSProperties } from "react";

/** Default dashboard (main.tsx) — sparkline line/bar styles (static hex, module scope). */
export const MAIN_SPARKLINE_LINE_RED: CSSProperties = {
  strokeWidth: 3,
  stroke: "#dc3545",
  fill: "none"
};

export const MAIN_SPARKLINE_LINE_THEME: CSSProperties = {
  strokeWidth: 3,
  stroke: "#922c88",
  fill: "none"
};

export const MAIN_SPARKLINE_BARS_PURPLE: CSSProperties = {
  stroke: "white",
  strokeWidth: "1",
  fill: "#922c88"
};

export const MAIN_SPARKLINE_LINE_THEME_FILLED: CSSProperties = {
  strokeWidth: 3,
  stroke: "#922c88",
  fill: "#922c88",
  fillOpacity: "1"
};

export const MAIN_SPARKLINE_SPOTS_INCOME: CSSProperties = {
  stroke: "red",
  strokeWidth: 3,
  fill: "white"
};
